import { toast } from 'sonner'
import { AppPaths } from '@/config/app-paths'
import { clearWorkspaceSession } from '@/features/auth/session/workspace-session'
import { enMessages } from '@/shared/i18n/messages/en'

const SESSION_EXPIRED_MESSAGE = enMessages.errors.code.unauthorized

let handling = false

type SessionExpiredDeps = {
  clearQueries: () => void
}

let deps: SessionExpiredDeps | null = null

/** @internal Resets module state between unit tests. */
export function resetSessionExpiredStateForTests(): void {
  handling = false
  deps = null
}

/** Register once from AppProviders so forced relogin can clear TanStack Query cache. */
export function registerSessionExpiredHandler(next: SessionExpiredDeps): () => void {
  deps = next
  return () => {
    if (deps === next) deps = null
  }
}

/**
 * Clears session, notifies the user, and sends them to login.
 * Safe to call from axios interceptors (deduped).
 */
export function forceSessionExpired(): void {
  if (handling) return
  handling = true

  clearWorkspaceSession()
  deps?.clearQueries()

  const path = window.location.pathname
  const alreadyOnLogin =
    path === AppPaths.login || path.startsWith(`${AppPaths.login}/`)
  if (alreadyOnLogin) {
    // Allow a later logout/expiry after the user signs in again this tab.
    handling = false
    return
  }

  toast.error(SESSION_EXPIRED_MESSAGE)

  const returnUrl = encodeURIComponent(
    `${window.location.pathname}${window.location.search}`,
  )
  window.location.replace(`${AppPaths.login}?returnUrl=${returnUrl}`)
}
